import React,{useEffect,useState} from "react";

import { useRouteMatch,Switch, Route } from "react-router-dom";
import PlayerCardV1 from "./PlayerCardV1";

  const PlayerPageMain =({})=>{
    
      const {url} =useRouteMatch();
    return(<>
    <Switch>
{/* <Route exact path={`${url}`}>
    <PlayerCardV1  />
</Route> */}
<Route  path={`/player/:course?/:courseId?/:subcourse?/:subCourseId?/:item?/:itemId?/:itemToken?/:itemStatus?`}>
    <PlayerCardV1  />
</Route>



</Switch>
    </>)
  }
  export default PlayerPageMain